import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/cp4i-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`The DemoHub for Cloud Pak for Integration is the place to find demos for Cloud Pak for Integration.`}</p>
      <p>{`IBM Cloud Pak for Integration offers a complete set of integration capabilities to efficiently connect your applications and data wherever they live`}</p>
    </PageDescription>
    <h2>{`Demos offered`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Sales Demos`}</strong>{` – open `}<a parentName="p" {...{
            "href": "../salesdemos/"
          }}>{`salesdemos`}</a>{` to read more.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Learn with Labs`}</strong>{` – open `}<a parentName="p" {...{
            "href": "../tutorials/"
          }}>{`tutorials`}</a>{` to read more.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Community resources`}</strong>{` – open `}<a parentName="p" {...{
            "href": "../community/"
          }}>{`community`}</a>{` to read more.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`References`}</strong>{` – open `}<a parentName="p" {...{
            "href": "../resources/"
          }}>{`resources`}</a>{` to read more.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      